import { render, staticRenderFns } from "./QuanLyDTV.vue?vue&type=template&id=779b1c90&scoped=true&"
import script from "./QuanLyDTV.vue?vue&type=script&lang=js&"
export * from "./QuanLyDTV.vue?vue&type=script&lang=js&"
import style0 from "./QuanLyDTV.vue?vue&type=style&index=0&id=779b1c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b1c90",
  null
  
)

export default component.exports